import { render, staticRenderFns } from "./partner_login.vue?vue&type=template&id=959d9114&lang=pug"
import script from "./partner_login.vue?vue&type=script&lang=js"
export * from "./partner_login.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports